import { ILeaseTransferViewModel } from '../types/leaseTransferViewModel'

export class leaseTransferViewModel implements ILeaseTransferViewModel
{
    dealerName: string = ''
    dealerAddress: string = ''
    dealerPhone: string = ''
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingLeaseTransferRequest: boolean = false
    existingLeaseTransferRequestId: string = ''
    referenceNumber: string = ''
}